import {
  ContractEntryPointAccess,
  DeployEntryPointName,
  DeployResultWithInfo,
} from '@block-explorer/entities';
import { WASM_DEPLOY, WASM_PROXY_DEPLOY } from './currency';
import { NamedKeyPrefix } from '@make-software/cspr-design';

export const hasContractHashPrefix = (contractHash?: string | null) =>
  [
    NamedKeyPrefix.CONTRACT_PACKAGE,
    NamedKeyPrefix.CONTRACT,
    NamedKeyPrefix.HASH,
  ].some((prefix) => contractHash?.startsWith(prefix));

//TODO: MOVE TO LIB
export const ExecutionTypesMap = {
  1: 'WASM', //"ModuleBytes"
  2: 'Contract call', //"StoredContractByHash"
  3: 'Contract call', //"StoredContractByName",
  4: 'Contract call', //"StoredVersionedContractByHash",
  5: 'Contract call', //"StoredVersionedContractByName",
  6: 'Native',
  7: 'WASM',
};

/**
 * Check if the Deploy is a transfer deploy by comparing native trasfer contract hash and entrypoint name, return TRUE
 * @param contractHash
 * @param entryPointName
 */
export const isTransferDeploy = (
  contractHash: string | null,
  entryPointName: string | null | undefined
) => {
  return (
    contractHash === config.native_transfer_contract_hash &&
    entryPointName === DeployEntryPointName.TRANSFER
  );
};

/**
 * Check if the Deploy is a WASM deploy, return TRUE
 * @param executionTypeId
 */
export const isWASMTransaction = (executionTypeId: number) => {
  return executionTypeId === WASM_DEPLOY;
};

/**
 * Check if the Deploy is a WASM deploy, return TRUE
 * @param executionTypeId
 */
export const isWASMProxyTransaction = (executionTypeId: number) => {
  return executionTypeId === WASM_PROXY_DEPLOY;
};

/**
 * Check if the Transaction is an ODRA WASM Proxy, return TRUE
 * @param transaction
 */
export const isODRAWasmProxyTransaction = (
  transaction: DeployResultWithInfo
): boolean => {
  return Boolean(
    isWASMProxyTransaction(transaction.executionTypeId) &&
      transaction.args?.amount &&
      transaction.args?.attached_value
  );
};

export const isPrivateEntryPointAccess = (
  access: ContractEntryPointAccess
): boolean =>
  !(
    access === 'Public' ||
    (typeof access === 'object' &&
      ('Public' in access || access.isPublic === true))
  );
